const tables = [
  {
    name: "Purchase",
  },
  {
    name: "Date",
  },
  {
    name: "Amount",
  },
  {
    name: "Payment",
  },
  {
    name: "Action",
  },
];

export default tables;
